import React, { Component } from "react";
import { StyledButton, DocumentViewer } from "components/support";
import { DocumentTypes } from "core/enum";

export default class ViewSaleButtonView extends Component {
  render() {
    const { presenter, viewModel, sale } = this.props;
    const { loading, document } = viewModel;
    const documentType = DocumentTypes[sale.document.type];
    if (sale.document.type === "devolution") {
      return (
        <div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <StyledButton
              primary
              style={{ fontSize: "12px", margin: "0px" }}
              label={`Ver ${documentType}`}
              onClick={() => presenter.onRequestSaleDocument()}
              loading={loading}
            />
          </div>
          <DocumentViewer
            title="Documento da Venda"
            onHide={() => presenter.onHideDocument()}
            visible={document.visible}
            documentName={document.name}
            data={document.blob}
          />
        </div>
      );
    } else {
      return (
        <div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <StyledButton
              primary
              style={{ fontSize: "12px", margin: "0px" }}
              label={
                !sale.document.serie
                  ? `Ver ${documentType} n.: ${sale.document.number}`
                  : `Ver ${documentType} s.: ${sale.document.serie} n.: ${sale.document.number}`
              }
              onClick={() => presenter.onRequestSaleDocument()}
              loading={loading}
            />
          </div>
          <DocumentViewer
            title="Documento da Venda"
            onHide={() => presenter.onHideDocument()}
            visible={document.visible}
            documentName={document.name}
            data={document.blob}
          />
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/support/view-sale-button/view.jsx